import { createContext } from "react";

export default createContext({
  languageInfo: {
    loading: true,
    languages: [],
  },
  setLanguageInfo: () => {},
});
